/* A Modal Window component for displaying content in a modal format */
import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useLang } from "../contexts/LangContext";
import { createPortal } from "react-dom";

const ModalWindow = ({
  isOpen,
  onClose,
  children,
  modalTitle = null,
  showClose = true,
}: {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  modalTitle?: string | null;
  showClose?: boolean;
}) => {
  const { t } = useLang();

  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black bg-opacity-60"
        onClick={onClose}
      ></div>
      <motion.div
        className="bg-transparent relative w-full max-w-xl"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
      >
        {showClose && (
          <button
            className="absolute -bottom-10 left-1/2 -translate-x-1/2 p-1 flex items-center justify-center bg-gray-200 rounded-full text-3xl text-gray-500  hover:text-gray-700 select-none"
            style={{ boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)" }}
            onClick={onClose}
            aria-label={t("close")}
          >
            <div className="flex items-center justify-center w-full h-full">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="size-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                />
              </svg>
              <span className="ml-1 mr-2 text-sm text-gray-500">
                {t("close")}
              </span>
            </div>
          </button>
        )}

        {/* {modalTitle && (
          <h2 className="text-xl text-white font-bold text-center mb-2"
            style={{ textShadow: "0px 0px 20px rgba(0, 0, 0, 1)" }}>
            {modalTitle}
          </h2>
        )} */}

        {children}
      </motion.div>
    </div>,
    document.body
  );
};

export default ModalWindow;
export { ModalWindow };
